module.exports = __webpack_public_path__ + "media/app/components/Footer/AppStoreVi.b59540bf.svg";